import { useAuth } from '@/services/auth';

/**
 * The account a user's per-environment settings live under.
 *
 * While masquerading, the signed-in admin belongs to the Customer.io admin
 * account, and `auth.user.account_id` points at the account being *viewed* —
 * so the settings read and write under the admin account instead. The
 * settings belong to the person reading, not to the workspace they are
 * reading: writing them under the viewed account would save one customer's
 * choices onto another's record. Mirrors Ember's `replaceAccountID` handling
 * in `user.getUserSettings` / `updateUserSettings`.
 */
const MASQ_ADMIN_ACCOUNT_ID = 1;

export function useSettingsAccountId(): number | undefined {
  const { account, user } = useAuth();
  if (user == null) {
    return undefined;
  }
  return account?.is_masq === true ? MASQ_ADMIN_ACCOUNT_ID : user.account_id;
}
